<template>
  <div class="base-popup-content">
    <div v-if="$slots.title" class="base-popup-content__title">
      <slot name="title" />
    </div>
    <div v-if="$slots.body" class="base-popup-content__body">
      <slot name="body" />
    </div>
    <div v-if="$slots.actions" class="base-popup-content__actions">
      <slot name="actions" v-bind="{ rowStyle, columnStyle }" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CSSProperties } from 'vue'

const rowStyle = computed<CSSProperties>(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
}))
const columnStyle = computed<CSSProperties>(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
}))
</script>

<style lang="scss" scoped>
.base-popup-content {
  > * {
    padding-left: rem(70px);
    padding-right: rem(70px);

    @include bp-media('xs', 'sm') {
      padding-left: rem(35px);
      padding-right: rem(35px);
    }

    @include bp-media('xs') {
      padding-left: rem(16px);
      padding-right: rem(16px);
    }

    &:first-child {
      padding-top: rem(46px);

      @include bp-media('xs') {
        padding-top: rem(38px);
      }
    }

    &:last-child {
      padding-bottom: rem(40px);

      @include bp-media('xs') {
        padding-bottom: rem(30px);
      }
    }
  }

  &__title {
    @include typo-h6;

    text-align: center;
    text-transform: uppercase;
    margin-bottom: rem(16px);
  }

  &__body {
    @include typo-text;

    text-align: center;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: rem(12px);
    margin-top: rem(27px);
  }

  > .base-popup-content__body:only-child {
    padding: rem(40px);

    @include bp-media('xs') {
      padding-bottom: rem(30px);
    }
  }
}
</style>
